import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { FeaturedReviewModel } from '@app/shared/models/api/featured-review.model';
import { Observable } from 'rxjs';
import { StarFilledIconComponent } from '../../../shared/components/icons/generated/star-filled/star-filled.component';
import { NgFor, NgIf, AsyncPipe, SlicePipe } from '@angular/common';
import { TickOutlinedIconComponent } from '../../../shared/components/icons/generated/tick-outlined/tick-outlined.component';
import { TranslocoModule } from '@ngneat/transloco';
import { StarHalfFilledIconComponent } from '@app/shared/components/icons/generated/star-half-filled/star-half-filled.component';

@Component({
  selector: 'app-featured-reviews-item',
  templateUrl: './featured-reviews-item.template.html',
  styleUrls: ['./featured-reviews-item.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    TickOutlinedIconComponent,
    RouterLink,
    NgFor,
    StarFilledIconComponent,
    StarHalfFilledIconComponent,
    NgIf,
    AsyncPipe,
    SlicePipe,
  ],
})
export class FeaturedReviewsItemComponent implements OnChanges {
  @Input() public review?: FeaturedReviewModel | null;
  @Input() public darkMode?: boolean | null = false;

  public readonly biggerThan$: Observable<ScreenSizeInfoState>;

  public urlFragments: string | string[];
  public queryParameters: Params;
  public readMore = false;

  public isAverageRatingPointFive = false;

  public ratingIterate: Array<number>;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.queryParameters = {
      ...this.akitaRouterQuery.queryParamsToKeep,
      models: this.review?.model,
    };
    this.urlFragments = '';
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();

    this.ratingIterate = this.range(this.review?.rating);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.review) {
      this.urlFragments = this.getSearchUrlFragment();
      this.queryParameters = {
        ...this.akitaRouterQuery.queryParamsToKeep,
        models: this.review?.model,
      };
      this.isAverageRatingPointFive =
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        (this.review?.rating || 0) % 1 >= 0.4;
      this.ratingIterate = this.range(this.review?.rating);

      this.changeDetector.markForCheck();
    }
  }

  public range(length: number | undefined): Array<number> {
    return new Array(parseInt(`${length || 0}`, 10));
  }

  public trackByIndex(index: number): string {
    return `${index}`;
  }

  public getSearchUrlFragment(): Array<string> | string {
    return this.akitaRouterQuery.getPhoneSearchFragment();
  }
}
